module.exports = __webpack_public_path__ + "img/warp_beast_mana_eater.fdbf12c6.png";